<template>
  <div :id="idChart"></div>
</template>

<script>
import moment from "moment";
import Highcharts from "highcharts";
import Exporting from "highcharts/modules/export-data";
import Accessibility from "highcharts/modules/accessibility";
Accessibility(Highcharts);
Exporting(Highcharts);
export default {
  name: "RainHistoricChart",
  props: ["location", "minDaysForecast", "forecasts"],
  data: () => ({
    idChart: "container-rain-historic-chart",
    chartRendered: undefined,
  }),
  methods: {
    chartPreprocessing() {
      const elementId = this.idChart;
      let chart = document.getElementById(elementId);
      let series = [];
      series = [
        this.createDataSerie(
          this.formatChartValues(this.forecasts),
          "Chuva estimada",
          "column",
          "mm",
          1
        ),
      ];
      if (series) {
        this.charts(elementId, series);
        this.loading = false;
        chart.style.visibility = "visible";
        chart.style.display = "block";
      } else {
        chart.style.visibility = "hidden";
        chart.style.display = "none";
      }

      this.$emit("chartRenderComplete", this.chartRendered);
    },
    async charts(elementId, series) {
      Highcharts.setOptions({
        lang: {
          months: [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro",
          ],
          shortMonths: [
            "Jan",
            "Fev",
            "Mar",
            "Abr",
            "Mai",
            "Jun",
            "Jul",
            "Ago",
            "Set",
            "Out",
            "Nov",
            "Dez",
          ],
          weekdays: [
            "Domingo",
            "Segunda",
            "Terça",
            "Quarta",
            "Quinta",
            "Sexta",
            "Sábado",
          ],
        },
      });
      this.chartRendered = Highcharts.chart(elementId, {
        colors: ["#95A1EC", this.$vuetify.theme.themes.dark.primary.base],
        colorAxis: {
          gridLineColor: this.$vuetify.theme.themes.dark.primary.darken1,
        },
        chart: {
          //type: type,
          backgroundColor: this.$vuetify.theme.themes.dark.primary.darken1,
          height: 300,
        },
        plotOptions: {
          column: {
            borderWidth: 0,
          },
        },
        exporting: {
          enabled: false,
          filename: `historico-estimativa-de-chuva - ${this.location.text}`,
          sourceWidth: 1000,

          chartOptions: {
            title: {
              text: `Histórico da estimativa de chuva - ${
                this.location ? this.location.text : ""
              }`,
              style: {
                color: "#FFFFFF",
              },
            },
            subtitle: {
              text: `${moment().subtract(179, "days").format("DD/MM/YYYY")} até ${moment().format("DD/MM/YYYY")}`,
              style: {
                color: "#FFFFFF",
              },
            },

            xAxis: {
              tickInterval: 24 * 3600 * 1000,
            },
          },
        },
        title: {
          text: "",
        },
        credits: {
          enabled: true,
          href: "http://www.simepar.br/",
          text: "by: SIMEPAR",
          style: {
            color: "#FFFFFF",
          },
        },
        legend: {
          enabled: true,
          itemStyle: {
            color: "#FFFFFF",
          },
          itemHoverStyle: {
            color: "#979797",
          },
        },
        xAxis: {
          accessibility: {
            description: `De ${moment(this.forecasts[0].date).format("DD/MM/YYYY")} até ${moment(this.forecasts[this.forecasts.length-1].date).format("DD/MM/YYYY")}`,
          },
          gridLineWidth: 1,
          gridLineColor: "#2D324F",
          tickColor: "#2D324F",
          tickWidth: 2,
          lineWidth: 2,
          lineColor: "#2D324F",
          type: "datetime",
          ordinal: false,
          crosshair: {
            enabled: true,
          },
          labels: {
            format: "{value:%d/%m/%Y}",
            style: {
              color: "#FFFFFF",
            },
          },
        },
        yAxis: [
          {
            type: "numeric",
            min: 0,
            title: {
              text: "Histórico da estimativa (mm)",
              style: {
                color: "#FFFFFF",
              },
            },
            accessibility: {
              description: "Histórico da estimativa (mm)",
            },
            labels: {
              format: "{value}",
              style: {
                color: "#FFFFFF",
              },
            },
            lineWidth: 2,
            lineColor: "#2D324F",
            gridLineWidth: 1,
            gridLineColor: "#2D324F",
            resize: {
              enabled: true,
            },
            reversed: true,
            opposite: false,
          },
        ],
        tooltip: {
          //enabled: true,
          shared: true,
          split: true,
          //crosshairs: true,
          useHTML: true,
          xDateFormat: '%d/%m/%Y',// "%A, %b %d",
          pointFormatter: function () {
            const value = this.series.userOptions.valueDecimals
              ? Number(this.y).toFixed(this.series.userOptions.valueDecimals)
              : this.y;
            return (
              '<strong style="color:' +
              this.series.color +
              '">' +
              this.series.name +
              "</strong>: <strong>" +
              value +
              " " +
              this.series.userOptions.valueSuffix +
              "<strong/>"
            );
          },
        },
        series: series,
        caption: {
          text: `Gráfico do histórico da estimativa de chuva de ${moment(this.forecasts[0].date).format("DD/MM/YYYY")}  até ${moment(this.forecasts[this.forecasts.length-1].date).format("DD/MM/YYYY")}`,
          style: { color: "#FFFFFF" },
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom",
                },
              },
            },
          ],
        },
      });
    },
    createDataSerie(data, name, type, valueSuffix, valueDecimals) {
      let serie = { type, name, valueSuffix, valueDecimals };
      serie.data = [];
      for (let i in data) {
        let arrayItem = [];
        let x = this.dateToUTC(data[i].date);
        let y = data[i].value;
        arrayItem.push(x);
        arrayItem.push(y);
        serie.data.push(arrayItem);
      }

      return serie;
    },
    formatChartValues(forecasts) {
      let data = [];
      if (forecasts) {
        for (const key in forecasts) {
          data.push({ value: Number(forecasts[key].value.precIntensity), date: forecasts[key].date });
        }
      }
      return data;
    },
    dateToUTC(date) {
      const utc = moment(date, "YYYY-MM-DD"); //.locale('en').format('DD/MM');
      return utc.valueOf();
    },
  },
};
</script>

<style></style>
